import { render, staticRenderFns } from "./Deal.vue?vue&type=template&id=aa4a588c&scoped=true&"
import script from "./Deal.vue?vue&type=script&lang=ts&"
export * from "./Deal.vue?vue&type=script&lang=ts&"
import style0 from "./Deal.vue?vue&type=style&index=0&id=aa4a588c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4a588c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VContainer})
